import { useMutation } from "@tanstack/react-query";
import api from "apis";

const useNoticeMutation = () => {
  return useMutation({
    mutationFn: api.notice.postCreateNotice,
  });
};

export default useNoticeMutation;
